<template>
  <v-container fluid>
    <ListObject 
      :objectType="objectType" 
      :url="url" 
      :selectRow="selectRow" 
      :headers="headers" 
      :create="create" 
      :filtersData="filtersData"
      :deleteMsg="deleteMsg"
      :errorMsg="errorMsg"
    ></ListObject>
  </v-container>
</template>

<script>
import ListObject from '../components/ListObject.vue'
export default {
  components: {
    ListObject,
  },
  
  data() {
    return {
      objectType: "Company",
      url: "companies/",
      create: "create-company",
      update: "company-update",
      headers:[
        {text: "Actions", value: "actions" ,width: 160},
        {text: "NIF", value: "nif", width: 160},
        {text: "Name", value: "name", width: 160},
        {text: "Suppliers", value: "suppliers_names", width: 160},
        {text: "Customers", value: "customers_names", width: 160}
      ],
      filtersData: [
        {
          'name': 'nif__icontains', 
          'label': 'NIF'
        },
        {
          'name': 'name__icontains', 
          'label': 'Name'
        },
      ],
      // deleteMsg: "You will remove this company. Are you sure?",
      // errorMsg: "It was not possible to delete this company.",
      deleteMsg: "¿Estás seguro de que quieres borrar esta compañía?",
      errorMsg: "No se ha podido borrar esta compañía.",
    }
  },
  methods: {
    selectRow(data) {
      //this.$store.dispatch('configuration/setForceRightBar',true);
      var params = { name: this.update, params: { 'company': data.id } };
      this.$router.push(params);
    },
  },
};
</script>

<style>
</style>
